import { z } from 'zod';
import {
  compareModes,
  compareRange,
  customCompareRule,
  dateRangeSpec,
  filterNode,
  granularities,
  maxDimensions,
  memberName,
  timeModes,
} from '@qronstat/shared';
import { visualizationIds } from '@qronstat/ui/charts/registry';
import type { VisualizationId } from '@qronstat/ui/charts/registry';

export const reportViews = visualizationIds;
export type ReportView = VisualizationId;

export const reportDefinition = z
  .object({
    view: z.enum(reportViews),
    metrics: z.array(memberName).max(10).default([]),
    dimensions: z.array(memberName).max(maxDimensions).default([]),
    period: dateRangeSpec.default({ preset: 'last30' }),
    granularity: z.enum(granularities).optional(),
    compare: z.enum(compareModes).default('none'),
    compareRange: compareRange.optional(),
    filters: z.array(filterNode).max(50).default([]),
    realOnly: z.boolean().default(true),
    timeMode: z.enum(timeModes).default('msk'),
    events: z.array(z.string().max(60)).max(10).optional(),
    stacked: z.boolean().optional(),
    limit: z.number().int().min(1).max(1000).default(100),
  })
  .strict()
  .refine(customCompareRule.check, customCompareRule.message);

export type ReportDefinition = z.output<typeof reportDefinition>;
export type ReportDefinitionInput = z.input<typeof reportDefinition>;

export function emptyReport(): ReportDefinition {
  return reportDefinition.parse({ view: 'table' });
}
